export default __webpack_public_path__ + "static/media/12.e7ad7b80.jpg";